module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='	<div id="lineChartDetail" class="modal hide fade modal-chart-detail" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" style="display:none">\n		<div class="modal-header">\n			<button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>\n			<a class="arangoHeader">'+
((__t=(figure))==null?'':__t)+
'</a>\n		</div>\n		<div id="dashboardDetailedLineChart" class="dashboardDetailChart" style="position: absolute"></div>\n	</div>\n';
}
return __p;
};
